import IconDashboard from '~icons/ps/dashboard'
import IconDocumentSearch from '~icons/heroicons-outline/document-search'
import IconChart from '~icons/ic/sharp-show-chart'
import PhUsersThree from '~icons/ph/users-three'
import PhUsersFour from '~icons/ph/users-four'
import PhSignOut from '~icons/ph/sign-out'
import PhUserPlus from '~icons/ph/user-plus'
import PhUserSwitch from '~icons/ph/user-switch'
import PhSignatureLight from '~icons/ph/signature-light'
import IcOutlinePlaylistAdd from '~icons/ic/outline-playlist-add'
import IcBaselineList from '~icons/ic/baseline-list'
import MdiFormatListText from '~icons/mdi/format-list-text'
import MdiCashCheck from '~icons/mdi/cash-check'
import MdiCashClock from '~icons/mdi/cash-clock'
import MdiCashFast from '~icons/mdi/cash-fast'
import MaterialSymbolsGooglerTravel from '~icons/material-symbols/googler-travel'
import MaterialSymbolsAssignmentAddOutlineSharp from '~icons/material-symbols/assignment-add-outline-sharp'
import MaterialSymbolsAssignmentOutlineRounded from '~icons/material-symbols/assignment-outline-rounded'
import IcBaselinePersonSearch from '~icons/ic/baseline-person-search'
import MaterialSymbolsEventNoteOutlineRounded from '~icons/material-symbols/event-note-outline-rounded'
import PhChartLineUpLight from '~icons/ph/chart-line-up-light'
import MaterialSymbolsNestClockFarsightAnalogOutlineRounded from '~icons/material-symbols/nest-clock-farsight-analog-outline-rounded'
import { guardHrAlumniAccess, guardHrAccess, guardHrCreateResource, guardHrStatsAccess, guardHrHeadcountAccess, guardEmployeeOnboardingAccess, guardHrCanSeeWages, guardSignatureCampaignAccess, guardSettingsAccess as guardHrSettingsAccess } from '@/config/router/navigationsGuards/guardHr'
import {
  guardApiUsers,
  guardConsumption,
  guardPersonalisation,
  guardDataClients,
  guardDataDegrees,
  guardDataInvoicingInformations,
  guardDataJobs,
  guardDataOffices,
  guardDataResources,
  guardDataRooms,
  guardDataSkills,
  guardDataTeams,
  guardDataUserGroups,
  guardOpenReplay,
  guardIntegrations,
  guardProfiles,
  guardSessions,
  guardUsers,
} from '@/config/router/navigationsGuards/guardSuperAdmin'
import { guardCashFlow, guardDashboardAccess, guardProduction, guardResource, guardSales } from '@/config/router/navigationsGuards/guardDashboard'
import { guardPlanningResource, guardProjectAccess, guardProjectAdvancement, guardProjectCreation, guardSettings as guardProjectSettingsAccess } from '@/config/router/navigationsGuards/guardProject'
import { guardTimesheetAccess, guardTimesheetSettingsAccess } from '@/config/router/navigationsGuards/guardTimesheet'
import { guardCalendar, guardLeaveAccess, guardLeaveSettingsAccess, guardNewBulkRequest, guardNewRequest, guardRequest, guardLeaveAccounts} from '@/config/router/navigationsGuards/guardLeave'
import { guardCampaign, guardCreationEvaluation, guardEditEvaluation, guardEvaluationAccess, guardSummaries, guardSettingsAccess as guardEvaluationSettingsAccess } from '@/config/router/navigationsGuards/guardEvaluation'
import { guardExpenseAccess, guardExpenseCreation, guardExpenseSettings } from '@/config/router/navigationsGuards/guardExpense'
import { canAccessManagementPage } from '@/config/router/navigationsGuards/guardManagement'
import {
  canUserAccessModule,
  guardElearningAccess,
  guardMyTraining,
  guardTrainingAccess,
  guardTrainingBudget,
  guardTrainingCatalog,
  guardTrainingSettingsAccess,
  guardTrainingStats,
  guardTrainingWishesAttribution,
} from '@/config/router/navigationsGuards/guardTraining'
import { guardCandidateBase, guardCreateCandidate, guardJobBoard, guardJobBoardAdmin, guardMyMeetings, guardPipe, guardRecommendCandidate, guardRecruitmentAccess, guardRecruitmentCalendar, guardRecruitmentStatsAccess, guardScreening, guardSettingsAccess } from '@/config/router/navigationsGuards/guardRecruitment'
import {
  guardActivities,
  guardClients,
  guardContacts,
  guardSalesFunnelAccess,
  guardStats,
  guardWorkflows,
} from '@/config/router/navigationsGuards/guardSalesFunnel'
import MaterialSymbolsEditDocumentOutlineRounded from '~icons/material-symbols/edit-document-outline-rounded'
import SolarCaseOutline from '~icons/solar/case-outline'
import SolarPaintRollerLineDuotone from '~icons/solar/paint-roller-line-duotone'
import PhGearSixThin from '~icons/ph/gear-six-thin'
import MdiTimelineClockOutline from '~icons/mdi/timeline-clock-outline'
import SolarUserPlusLineDuotone from '~icons/solar/user-plus-line-duotone'
import SolarCalendarLineDuotone from '~icons/solar/calendar-line-duotone'
import SolarDocumentsLineDuotone from '~icons/solar/documents-line-duotone'
import PhKanbanLight from '~icons/ph/kanban-light'
import SolarSuitcaseBroken from '~icons/solar/suitcase-broken'
import SolarDatabaseLineDuotone from '~icons/solar/database-line-duotone'
import SolarBillListLineDuotone from '~icons/solar/bill-list-line-duotone'
import SolarDocumentAddLineDuotone from '~icons/solar/document-add-line-duotone'
import SolarChartOutline from '~icons/solar/chart-outline'
import SolarWalletMoneyOutline from '~icons/solar/wallet-money-outline'
import PhUserList from '~icons/ph/user-list'
import SolarMoneyBagLineDuotone from '~icons/solar/money-bag-line-duotone'
import SolarChartLineDuotone from '~icons/solar/chart-line-duotone'
import SolarDocumentTextLineDuotone from '~icons/solar/document-text-line-duotone'
import SolarDocumentMedicineBroken from '~icons/solar/document-medicine-broken'
import SolarCalculatorMinimalisticBroken from '~icons/solar/calculator-minimalistic-broken'
import PhAirplaneTakeoffLight from '~icons/ph/airplane-takeoff-light'
import PhChartDonutDuotone from '~icons/ph/chart-donut-duotone'
import PhTestTube from '~icons/ph/test-tube'
import PhUserSoundDuotone from '~icons/ph/user-sound-duotone'
import SolarSquareAcademicCap2LineDuotone from '~icons/solar/square-academic-cap-2-line-duotone'
import { guardInvoiceAccess, guardInvoiceSettingsAccess, isEInvoicingSalesEnabled } from '@/config/router/navigationsGuards/guardInvoice'
import { guardTicketAccess } from '@/config/router/navigationsGuards/guardTicket'
import SolarCalculatorLinear from '~icons/solar/calculator-linear'
import PhTicketLight from '~icons/ph/ticket-light'
import PhListMagnifyingGlassDuotone from '~icons/ph/list-magnifying-glass-duotone'
import SolarFileTextLineDuotone from '~icons/solar/file-text-line-duotone'
import MdiTransmissionTower from '~icons/mdi/transmission-tower'
import SolarMonitorLineDuotone from '~icons/solar/monitor-line-duotone'
import SolarClipboardListLineDuotone from '~icons/solar/clipboard-list-line-duotone'
import SolarClipboardCheckLineDuotone from '~icons/solar/clipboard-check-line-duotone'
import SolarChart2Outline from '~icons/solar/chart-2-outline'
import SolarGraphOutline from '~icons/solar/graph-outline'
import SolarUserBold from '~icons/solar/user-bold'
import MdiBellAlertOutline from '~icons/mdi/bell-alert-outline'
import { guardAlertAccess, guardBuilder, guardMonitor } from '@/config/router/navigationsGuards/guardAlert'
import { guardMySurveys, guardSurveyAccess, guardSurveyManage, guardSurveySettingsAccess } from '@/config/router/navigationsGuards/guardSurvey'
import SolarChecklistBold from '~icons/solar/checklist-bold'
import PhSuitcaseSimpleLight from '~icons/ph/suitcase-simple-light'
import PhAddressBookLight from '~icons/ph/address-book-light'
import PhLightbulbLight from '~icons/ph/lightbulb-light'
import PhGraduationCapLight from '~icons/ph/graduation-cap-light'
import PhBuildingsLight from '~icons/ph/buildings-light'
import PhPlugs from '~icons/ph/plugs'
import PhPlugsConnected from '~icons/ph/plugs-connected'
import SolarVideoFramePlayHorizontalOutline from '~icons/solar/video-frame-play-horizontal-outline'

export const bgColors = {
  'primary': 'text-white bg-primary-500',
  'primary-op': 'bg-primary-400/20 text-primary-700 dark:bg-primary-500/20 dark:text-primary-400 border dark:border-primary-700/30 border-primary-400/30',
  'success': 'text-white bg-success-500',
  'success-op': 'bg-success-400/20 text-success-700 dark:bg-success-500/20 dark:text-success-500 border dark:border-success-700/30 border-success-400/30',
  'warning': 'text-white bg-warning-600/90',
  'warning-op': 'bg-warning-400/20 text-warning-600 dark:bg-warning-500/20 dark:text-warning-500 border border-warning-700/30',
  'base': 'bg-base border border-base',
  'base-varient': 'bg-fade border border-gray-500/30',
  'error': 'text-white bg-red-700',
  'error-op': 'bg-danger-400/20 text-danger-500 dark:bg-danger-500/20 dark:text-danger-400 border border-danger-700/30',
  'errorLight': 'text-white bg-red-400',
  'errorLight-op': 'bg-danger-300/20 text-danger-300 dark:bg-danger-300/20 dark:text-danger-300 border border-danger-700/30',
  'loading': 'opacity-70',
  'disabled': 'text-white text-shadow bg-gray-500 dark:bg-gray-600',
  'disabled-op': 'text-gray-800/70 dark:text-gray-300 bg-gray-600/20 dark:bg-gray-500/20 border border-gray-500/30',
  'disabledLight': 'bg-fade',
  'transparent': 'bg-transparent',
  'blue-op': 'bg-blue-400/20 text-blue-700 dark:bg-blue-500/20 dark:text-blue-400 border dark:border-blue-700/30 border-blue-400/30',
  'purple-op': 'bg-purple-400/20 text-purple-700 dark:bg-purple-500/20 dark:text-purple-400 border dark:border-purple-700/30 border-purple-400/30',
  'orange-op': 'bg-orange-400/20 text-orange-700 dark:bg-orange-500/20 dark:text-orange-400 border dark:border-orange-700/30 border-orange-400/30',
}

export const borderColors = {
  'primary': 'border-primary-500',
  'primary-op': 'border-primary-400/30 dark:border-primary-700/30',
  'success': 'border-success-500',
  'success-op': 'border-success-400/30 dark:border-success-700/30',
  'warning': 'border-warning-500',
  'warning-op': 'border-warning-700/30',
  'base': 'border-base',
  'base-varient': 'border-gray-500/30',
  'error': 'border-red-700',
  'error-op': 'border-danger-700/30',
  'errorLight': 'border-red-400',
  'errorLight-op': 'border-danger-700/30',
  'loading': 'border-gray-400',
  'disabled': 'border-gray-500',
  'disabled-op': 'border-gray-500/30',
  'disabledLight': 'border-gray-300',
  'transparent': 'border-transparent',
}

export const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/

export enum labelColors {
  primary = 'bg-primary-400/20 text-primary-700 dark:bg-primary-500/20 dark:text-primary-500',
  'primary-plain' = 'bg-primary-400 text-gray-100 dark:bg-primary-500 dark:text-primary-100',
  success = 'bg-success-400/20 text-success-700 dark:bg-success-500/20 dark:text-success-500',
  'success-plain' = 'bg-success-400 text-success-800 dark:bg-success-500 dark:text-success-100',
  warning = 'bg-warning-400/20 text-warning-600 dark:bg-warning-500/20 dark:text-warning-500',
  'warning-plain' = 'bg-warning-500 text-warning-800 dark:bg-warning-500 dark:text-warning-100',
  base = 'bg-base border-base border',
  'base-varient' = 'bg-fade',
  error = 'bg-danger-400/20 text-danger-500 dark:bg-danger-500/20 dark:text-danger-400',
  'error-plain' = 'bg-danger-600 text-danger-100 dark:bg-danger-700 dark:text-danger-100',
  errorLight = 'bg-danger-300/20 text-danger-300 dark:bg-danger-300/20 dark:text-danger-300',
  loading = 'opacity-70',
  disabled = 'text-gray-50 text-shadow bg-gray-500 base-border',
  disabledLight = 'bg-fade',
  transparent = 'bg-transparent',
}
// error = 'bg-danger-500/80 text-danger-50 dark:bg-danger-500/20 dark:text-danger-500',

export enum size {
  dense = 'h-6 text-xs px-2 py-1',
  small = 'h-8 text-sm px-2 py-1',
  medium = 'h-10 text-base px-2 py-1',
  large = 'h-12 text-lg px-2 py-1',
}

export enum ModalPosition {
  base = 'b-modal',
  bottom = 'bottom-modal',
  right = 'right-modal',
  left = 'left-modal',
  top = 'top-modal',
  topFull = 'top-modal-full',
}

export const applicationColors = [null, '#e6194b', '#3cb44b', '#ffe119', '#4363d8', '#f58231', '#911eb4', '#46f0f0', '#f032e6', '#bcf60c', '#fabebe', '#008080', '#e6beff', '#9a6324',  '#ffd8b1', '#000075', '#808080','#00B4EB', '#C9E3DB', '#FEC925', '#FA1E44', '#53A586', '#6D78BF', '#000000']


// is in production
export const isProduction = import.meta.env.PROD
const isSandbox = location.hostname.split('.').includes('app-sandbox')

const shouldBeDisplayed = (acc, item) => {
  item.subPages = item.subPages.reduce((acc, item) => {
    if ((!isProduction || !item.isAlpha || (item.isAlpha && isSandbox)) && item.isDisplayed)
      acc.push(item)
    return acc
  }, [])

  if ((!isProduction || !item.isAlpha || (item.isAlpha && isSandbox)) && item.isDisplayed)
    acc.push(item)
  return acc
}

const canDisplaySuperAdminDataSection = () => [
  guardDataJobs(),
  guardDataClients(),
  guardDataDegrees(),
  guardDataSkills(),
  guardDataOffices(),
  guardDataRooms(),
  guardDataResources(),
  guardDataInvoicingInformations(),
  guardDataTeams(),
  guardDataUserGroups(),
].some((isAllowed) => isAllowed === true)

const canDisplaySuperAdminFirmSection = () => [
  guardPersonalisation(),
  guardConsumption(),
  guardOpenReplay(),
  guardIntegrations(),
].some((isAllowed) => isAllowed === true)

export const getDrawerMenuSuperAdmin = () => [
  {
    moduleId: 'SUPER_ADMIN',
    display: 'common.drawerSuperAdmin.users.title',
    isHeader: true,
    prependIcon: PhUsersThree,
    appendBadge: false,
    color: 'hover:border-primary-500 hover:bg-primary-500/25',
    moduleName: 'SUPER_ADMIN',
    isDisplayed: guardUsers() === true,
    subPages: [
      {
        moduleId: 'SUPER_ADMIN',
        isDisplayed: guardUsers() === true,
        display: 'common.drawerSuperAdmin.users.listOfUsers',
        route: 'SuperAdminUsers',
        isHeader: false,
        prependIcon: PhUsersThree,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 'SUPER_ADMIN',
        isDisplayed: guardProfiles() === true,
        display: 'common.drawerSuperAdmin.users.profileList',
        route: 'SuperAdminProfiles',
        isHeader: false,
        prependIcon: PhUsersThree,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 'SUPER_ADMIN',
        isDisplayed: guardSessions() === true,
        display: 'common.drawerSuperAdmin.users.sessions',
        route: 'SuperAdminSessions',
        isHeader: false,
        prependIcon: PhSignOut,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 'SUPER_ADMIN',
        isDisplayed: guardApiUsers() === true,
        display: 'common.drawerSuperAdmin.users.apiUsers',
        route: 'SuperAdminApiUsers',
        isHeader: false,
        prependIcon: PhPlugs,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
    ],
  },
  {
    moduleId: 'SUPER_ADMIN',
    display: 'common.drawerSuperAdmin.firm.title',
    isHeader: true,
    prependIcon: SolarCaseOutline,
    appendBadge: false,
    color: 'hover:border-primary-500 hover:bg-primary-500/25',
    moduleName: 'SUPER_ADMIN',
    isDisplayed: canDisplaySuperAdminFirmSection(),
    subPages: [
      {
        moduleId: 'SUPER_ADMIN',
        isDisplayed: guardPersonalisation() === true,
        display: 'common.drawerSuperAdmin.firm.personalisation',
        route: 'SuperAdminPersonalisation',
        isHeader: false,
        prependIcon: SolarPaintRollerLineDuotone,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 'SUPER_ADMIN',
        isDisplayed: guardConsumption() === true,
        display: 'common.drawerSuperAdmin.firm.consumptions',
        route: 'Consumption',
        isHeader: false,
        prependIcon: PhChartDonutDuotone,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 'SUPER_ADMIN',
        isDisplayed: guardOpenReplay() === true,
        display: 'common.drawerSuperAdmin.firm.openReplay',
        route: 'SuperAdminOpenReplay',
        isHeader: false,
        prependIcon: SolarVideoFramePlayHorizontalOutline,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 'SUPER_ADMIN',
        isDisplayed: guardIntegrations() === true,
        display: 'common.drawerSuperAdmin.firm.integrations',
        route: 'SuperAdminIntegrations',
        isHeader: false,
        prependIcon: PhPlugsConnected,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
    ],
  },
  {
    moduleId: 'SUPER_ADMIN',
    display: 'common.drawerSuperAdmin.data.title',
    isHeader: true,
    prependIcon: SolarCaseOutline,
    appendBadge: false,
    color: 'hover:border-primary-500 hover:bg-primary-500/25',
    moduleName: 'SUPER_ADMIN',
    isDisplayed: canDisplaySuperAdminDataSection(),
    subPages: [
      {
        moduleId: 'SUPER_ADMIN',
        isDisplayed: guardDataJobs() === true,
        display: 'common.drawerSuperAdmin.data.jobs',
        isBeta: false,
        route: 'Job',
        isHeader: false,
        prependIcon: PhSuitcaseSimpleLight,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 'SUPER_ADMIN',
        isDisplayed: guardDataClients() === true,
        display: 'common.drawerSuperAdmin.data.clients',
        route: 'Client',
        isBeta: false,
        isHeader: false,
        prependIcon: PhAddressBookLight,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 'SUPER_ADMIN',
        isDisplayed: guardDataDegrees() === true,
        display: 'common.drawerSuperAdmin.data.degrees',
        route: 'Degree',
        isBeta: false,
        isHeader: false,
        prependIcon: PhGraduationCapLight,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 'SUPER_ADMIN',
        isDisplayed: guardDataSkills() === true,
        display: 'common.drawerSuperAdmin.data.skills',
        route: 'Skill',
        isBeta: false,
        isHeader: false,
        prependIcon: PhLightbulbLight,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 'SUPER_ADMIN',
        isDisplayed: guardDataOffices() === true,
        display: 'common.drawerSuperAdmin.data.offices',
        route: 'Office',
        isBeta: false,
        isHeader: false,
        prependIcon: PhBuildingsLight,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 'SUPER_ADMIN',
        isDisplayed: guardDataRooms() === true,
        display: 'common.drawerSuperAdmin.data.rooms',
        route: 'Room',
        isBeta: false,
        isHeader: false,
        prependIcon: PhBuildingsLight,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 'SUPER_ADMIN',
        isDisplayed: guardDataResources() === true,
        display: 'common.drawerSuperAdmin.data.resources',
        route: 'DataResources',
        isBeta: false,
        isHeader: false,
        prependIcon: PhUsersThree,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 'SUPER_ADMIN',
        isDisplayed: guardDataInvoicingInformations() === true,
        display: 'common.drawerSuperAdmin.data.invoicingInformations',
        route: 'InvoicingInformation',
        isBeta: false,
        isHeader: false,
        prependIcon: SolarBillListLineDuotone,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 'SUPER_ADMIN',
        isDisplayed: guardDataTeams() === true,
        display: 'common.drawerSuperAdmin.data.organizationStructure',
        route: 'OrganizationStructure',
        isBeta: false,
        isHeader: false,
        prependIcon: SolarGraphOutline,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 'SUPER_ADMIN',
        isDisplayed: guardDataUserGroups() === true,
        display: 'common.drawerSuperAdmin.data.organizationGroups',
        route: 'OrganizationGroups',
        isBeta: false,
        isHeader: false,
        prependIcon: PhUsersThree,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
    ],
  }
].reduce(shouldBeDisplayed, [])

const canDisplayAdminFirmsSection = () => [
  canAccessManagementPage('ManagementAccounts'),
  canAccessManagementPage('ManagementServers'),
  canAccessManagementPage('ManagementCypressE2e'),
  canAccessManagementPage('ManagementStats'),
  canAccessManagementPage('ManagementUserActivity'),
  canAccessManagementPage('ManagementPricing'),
  canAccessManagementPage('ManagementInvoice'),
].some(Boolean)

const canDisplayAdminTicketsSection = () => [
  canAccessManagementPage('AdminTicketOverview'),
  canAccessManagementPage('AdminTicketBoard'),
  canAccessManagementPage('AdminTicketList'),
].some(Boolean)

const canDisplayAdminAiSection = () => canAccessManagementPage('ManagementAIHistory')

const canDisplayAdminAcademySection = () => canAccessManagementPage('ManagementAcademy')

// Admin menu - for users with role 'admin' and no firmId
export const getDrawerMenuAdmin = () => [
  {
    moduleId: 'ADMIN',
    display: 'common.drawerAdmin.firms.title',
    isHeader: true,
    prependIcon: SolarCaseOutline,
    appendBadge: false,
    color: 'hover:border-warning-500 hover:bg-warning-500/25',
    moduleName: 'ADMIN',
    isDisplayed: canDisplayAdminFirmsSection(),
    subPages: [
      {
        moduleId: 'ADMIN',
        isDisplayed: canAccessManagementPage('ManagementAccounts'),
        display: 'common.drawerAdmin.firms.list',
        route: 'ManagementAccounts',
        isHeader: false,
        prependIcon: SolarCaseOutline,
        appendBadge: false,
        color: 'hover:border-warning-500 hover:bg-warning-500/25',
      },
      {
        moduleId: 'ADMIN',
        isDisplayed: canAccessManagementPage('ManagementServers'),
        display: 'common.drawerAdmin.firms.servers',
        route: 'ManagementServers',
        isHeader: false,
        prependIcon: SolarDatabaseLineDuotone,
        appendBadge: false,
        color: 'hover:border-warning-500 hover:bg-warning-500/25',
      },
      {
        moduleId: 'ADMIN',
        isDisplayed: canAccessManagementPage('ManagementCypressE2e'),
        display: 'common.drawerAdmin.firms.e2e',
        route: 'ManagementCypressE2e',
        isHeader: false,
        prependIcon: PhTestTube,
        appendBadge: false,
        color: 'hover:border-warning-500 hover:bg-warning-500/25',
      },
      {
        moduleId: 'ADMIN',
        isDisplayed: canAccessManagementPage('ManagementStats'),
        display: 'common.drawerAdmin.firms.stats',
        route: 'ManagementStats',
        isHeader: false,
        prependIcon: PhChartDonutDuotone,
        appendBadge: false,
        color: 'hover:border-warning-500 hover:bg-warning-500/25',
      },
      {
        moduleId: 'ADMIN',
        isDisplayed: canAccessManagementPage('ManagementUserActivity'),
        display: 'common.drawerAdmin.firms.userActivity',
        route: 'ManagementUserActivity',
        isHeader: false,
        prependIcon: PhUsersThree,
        appendBadge: false,
        color: 'hover:border-warning-500 hover:bg-warning-500/25',
      },
      {
        moduleId: 'ADMIN',
        isDisplayed: canAccessManagementPage('ManagementPricing'),
        display: 'common.drawerAdmin.firms.pricing',
        route: 'ManagementPricing',
        isHeader: false,
        prependIcon: SolarMoneyBagLineDuotone,
        appendBadge: false,
        color: 'hover:border-warning-500 hover:bg-warning-500/25',
      },
      {
        moduleId: 'ADMIN',
        isDisplayed: canAccessManagementPage('ManagementInvoice'),
        display: 'common.drawerAdmin.firms.invoice',
        route: 'ManagementInvoice',
        isHeader: false,
        prependIcon: MdiCashCheck,
        appendBadge: false,
        color: 'hover:border-warning-500 hover:bg-warning-500/25',
      },
    ],
  },
  {
    moduleId: 'ADMIN',
    display: 'common.drawerAdmin.tickets.title',
    isHeader: true,
    prependIcon: PhTicketLight,
    appendBadge: false,
    color: 'hover:border-warning-500 hover:bg-warning-500/25',
    moduleName: 'ADMIN',
    isDisplayed: canDisplayAdminTicketsSection(),
    subPages: [
      {
        moduleId: 'ADMIN',
        isDisplayed: canAccessManagementPage('AdminTicketOverview'),
        display: 'common.drawerAdmin.tickets.overview',
        route: 'AdminTicketOverview',
        isHeader: false,
        prependIcon: PhChartDonutDuotone,
        appendBadge: false,
        color: 'hover:border-warning-500 hover:bg-warning-500/25',
      },
      {
        moduleId: 'ADMIN',
        isDisplayed: canAccessManagementPage('AdminTicketBoard'),
        display: 'common.drawerAdmin.tickets.board',
        route: 'AdminTicketBoard',
        isHeader: false,
        prependIcon: PhKanbanLight,
        appendBadge: false,
        color: 'hover:border-warning-500 hover:bg-warning-500/25',
      },
      {
        moduleId: 'ADMIN',
        isDisplayed: canAccessManagementPage('AdminTicketList'),
        display: 'common.drawerAdmin.tickets.list',
        route: 'AdminTicketList',
        isHeader: false,
        prependIcon: PhListMagnifyingGlassDuotone,
        appendBadge: false,
        color: 'hover:border-warning-500 hover:bg-warning-500/25',
      },
    ],
  },
  {
    moduleId: 'ADMIN',
    display: 'common.drawerAdmin.ai.title',
    isHeader: true,
    prependIcon: SolarMonitorLineDuotone,
    appendBadge: false,
    color: 'hover:border-warning-500 hover:bg-warning-500/25',
    moduleName: 'ADMIN',
    isDisplayed: canDisplayAdminAiSection(),
    subPages: [
      {
        moduleId: 'ADMIN',
        isDisplayed: canAccessManagementPage('ManagementAIHistory'),
        display: 'common.drawerAdmin.ai.history',
        route: 'ManagementAIHistory',
        isHeader: false,
        prependIcon: MdiTimelineClockOutline,
        appendBadge: false,
        color: 'hover:border-warning-500 hover:bg-warning-500/25',
      },
    ],
  },
  {
    moduleId: 'ADMIN',
    display: 'common.drawerAdmin.academy.title',
    isHeader: true,
    prependIcon: SolarSquareAcademicCap2LineDuotone,
    appendBadge: false,
    color: 'hover:border-warning-500 hover:bg-warning-500/25',
    moduleName: 'ADMIN',
    isDisplayed: canDisplayAdminAcademySection(),
    subPages: [
      {
        moduleId: 'ADMIN',
        isDisplayed: canAccessManagementPage('ManagementAcademy'),
        display: 'common.drawerAdmin.academy.catalog',
        route: 'ManagementAcademy',
        isHeader: false,
        prependIcon: SolarSquareAcademicCap2LineDuotone,
        appendBadge: false,
        color: 'hover:border-warning-500 hover:bg-warning-500/25',
      },
    ],
  },
].reduce(shouldBeDisplayed, [])

export const getDrawerMenu = (resource) => [
  {
    moduleId: 1,
    display: 'common.drawer.hrBase',
    isHeader: true,
    prependIcon: PhUsersThree,
    appendBadge: false,
    color: 'hover:border-primary-500 hover:bg-primary-500/25',
    moduleName: 'HR',
    isDisplayed: guardHrAccess() === true,
    subPages: [
      {
        moduleId: 1,
        isDisplayed: true,
        display: 'common.drawer.directory',
        route: 'HrBase',
        isHeader: false,
        prependIcon: PhUsersThree,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 1,
        isDisplayed: guardHrAlumniAccess() === true,
        display: 'common.drawer.alumniDirectory',
        route: 'HrAlumni',
        isAlpha: false,
        isHeader: false,
        prependIcon: PhUserSoundDuotone,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 1,
        isDisplayed: guardEmployeeOnboardingAccess() === true,
        display: 'common.drawer.onboarding',
        isBeta: false,
        route: 'Onboarding',
        isHeader: false,
        prependIcon: PhUserSwitch,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 1,
        isDisplayed: guardSignatureCampaignAccess() === true,
        display: 'common.drawer.signatureCampaigns',
        route: 'SignatureCampaigns',
        isHeader: false,
        prependIcon: PhSignatureLight,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 1,
        isDisplayed: guardHrCreateResource() === true,
        display: 'common.drawer.hrCreate',
        isAlpha: false,
        route: 'HrCreate',
        isHeader: false,
        prependIcon: PhUserPlus,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 1,
        isDisplayed: guardHrCanSeeWages() === true,
        display: 'common.drawer.wages',
        route: 'HrWages',
        isHeader: false,
        prependIcon: SolarMoneyBagLineDuotone,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 1,
        isDisplayed: guardHrStatsAccess() === true,
        display: 'common.drawer.hrStats',
        route: 'HrStats',
        isHeader: false,
        prependIcon: PhChartLineUpLight,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 1,
        isDisplayed: guardHrHeadcountAccess() === true,
        display: 'common.drawer.hrHeadcount',
        route: 'HrHeadcount',
        isHeader: false,
        prependIcon: PhUsersFour,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 1,
        isDisplayed: guardHrSettingsAccess() === true,
        isBeta: false,
        display: 'common.drawer.settings',
        route: 'HrSettings',
        isHeader: false,
        prependIcon: PhGearSixThin,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
    ],
  },
  {
    moduleId: 4,
    display: 'common.drawer.recruitment',
    isHeader: true,
    prependIcon: IconDocumentSearch,
    appendBadge: false,
    color: 'hover:border-primary-500 hover:bg-primary-500/25',
    isBeta: false,
    moduleName: 'RECRUITMENT',
    isDisplayed: guardRecruitmentAccess() === true,
    subPages: [
      {
        moduleId: 4,
        isDisplayed: guardMyMeetings() === true,
        display: 'common.drawer.myMeetings',
        route: 'Meetings',
        isHeader: false,
        isBeta: false,
        prependIcon: MdiTimelineClockOutline,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 4,
        isDisplayed: guardRecommendCandidate() === true,
        display: 'common.drawer.recommend',
        route: 'RecommendCandidate',
        isHeader: false,
        isBeta: false,
        prependIcon: MdiTimelineClockOutline,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 4,
        isDisplayed: guardCreateCandidate() === true, // FIXME get the right guard
        display: 'common.drawer.createCandidate',
        route: 'CreateCandidate',
        isHeader: false,
        isBeta: false,
        prependIcon: SolarUserPlusLineDuotone,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 4,
        isDisplayed: guardRecruitmentCalendar() === true,
        display: 'common.drawer.recruitmentCalendar',
        route: 'RecruitmentCalendar',
        isHeader: false,
        isBeta: false,
        prependIcon: SolarCalendarLineDuotone,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 4,
        isDisplayed: guardScreening() === true,
        display: 'common.drawer.screening',
        route: 'Screening',
        isHeader: false,
        isBeta: false,
        prependIcon: SolarDocumentsLineDuotone,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 4,
        isDisplayed: guardPipe() === true,
        display: 'common.drawer.recruitmentProcess',
        route: 'RecruitmentProcess',
        isHeader: false,
        isBeta: false,
        isAlpha: false,
        prependIcon: PhKanbanLight,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        display: 'common.drawer.recruitmentDatabase',
        isDisplayed: guardCandidateBase() === true,
        route: 'RecruitmentDatabase',
        isHeader: false,
        isBeta: false,
        isAlpha: false,
        prependIcon: SolarDatabaseLineDuotone,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        display: 'common.drawer.jobBoard',
        isDisplayed: guardJobBoard() === true,
        route: 'JobBoardAdmin',
        isHeader: false,
        isAlpha: false,
        isBeta: false,
        prependIcon: SolarSuitcaseBroken,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 4,
        isDisplayed: guardRecruitmentStatsAccess() === true, // statsAccess
        display: 'common.drawer.hrStats',
        route: 'RecruitmentStats',
        isHeader: false,
        prependIcon: PhChartLineUpLight,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 4,
        isDisplayed: guardSettingsAccess() === true,
        display: 'common.drawer.settings',
        route: 'RecruitmentSettings',
        isHeader: false,
        prependIcon: PhGearSixThin,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
    ],
  },
  {
    moduleId: 5,
    isDisplayed: guardProjectAccess() === true,
    display: 'common.drawer.project',
    isHeader: true,
    prependIcon: IconChart,
    appendBadge: false,
    color: 'hover:border-primary-500 hover:bg-primary-500/25',
    moduleName: 'PROJECT',
    subPages: [
      {
        moduleId: 5,
        isDisplayed: true,
        display: 'common.drawer.myStaffing',
        route: 'MyStaffing',
        isHeader: false,
        prependIcon: SolarCalendarLineDuotone,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 5,
        isDisplayed: guardProjectCreation() === true,
        display: 'common.drawer.createProject',
        route: 'ProjectCreation',
        isHeader: false,
        prependIcon: IcOutlinePlaylistAdd,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 5,
        isDisplayed: true,
        display: 'common.drawer.projectList',
        route: 'Projects',
        isHeader: false,
        prependIcon: MdiFormatListText,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 5,
        isDisplayed: guardProjectAdvancement() === true,
        display: 'common.drawer.projectAdvancement',
        route: 'ProjectsAdvancement',
        isHeader: false,
        prependIcon: MdiFormatListText,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 5,
        isDisplayed: guardPlanningResource() === true,
        display: 'common.drawer.projectResourcePlanning',
        route: 'ProjectPlanningResources',
        isHeader: false,
        prependIcon: IcBaselineList,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 5,
        isDisplayed: guardPlanningResource() === true,
        display: 'common.drawer.projectPlanning',
        route: 'ProjectPlanningProjects',
        isHeader: false,
        prependIcon: IcBaselineList,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 5,
        isDisplayed: guardProjectSettingsAccess() === true,
        display: 'common.drawer.projectSettings',
        route: 'ProjectSettings',
        isHeader: false,
        prependIcon: PhGearSixThin,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
    ],
  },
  {
    moduleId: 20,
    isDisplayed: guardTimesheetAccess() === true,
    display: 'common.drawer.timesheet',
    isHeader: true,
    prependIcon: MaterialSymbolsNestClockFarsightAnalogOutlineRounded,
    appendBadge: false,
    color: 'hover:border-primary-500 hover:bg-primary-500/25',
    moduleName: 'TIMESHEET',
    subPages: [
      {
        moduleId: 20,
        isDisplayed: guardTimesheetAccess() === true,
        display: 'common.drawer.timesheets',
        route: 'Timesheets',
        isHeader: false,
        prependIcon: MaterialSymbolsNestClockFarsightAnalogOutlineRounded,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 20,
        isDisplayed: guardTimesheetSettingsAccess() === true,
        display: 'common.drawer.settings',
        route: 'TimesheetSettings',
        isHeader: false,
        prependIcon: PhGearSixThin,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
    ],
  },
  {
    moduleId: 6,
    isDisplayed: guardLeaveAccess() === true,
    display: 'common.drawer.leave',
    isHeader: true,
    prependIcon: PhAirplaneTakeoffLight,
    appendBadge: false,
    color: 'hover:border-primary-500 hover:bg-primary-500/25',
    moduleName: 'LEAVE',
    subPages: [
      {
        moduleId: 6,
        isDisplayed: guardLeaveAccess() === true,
        display: 'common.drawer.leaveAccount',
        route: 'LeaveAccount',
        isHeader: false,
        prependIcon: SolarCalculatorMinimalisticBroken,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 6,
        isDisplayed: guardLeaveAccounts() === true,
        display: 'common.drawer.accounts',
        route: 'Accounts',
        isHeader: false,
        prependIcon: SolarCalculatorMinimalisticBroken,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 6,
        isDisplayed: guardRequest() === true,
        display: 'common.drawer.leaveRequest',
        route: 'LeaveRequests',
        isHeader: false,
        prependIcon: MaterialSymbolsAssignmentOutlineRounded,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 6,
        isDisplayed: guardNewRequest() === true,
        display: 'common.drawer.leaveNewRequest',
        route: 'NewLeaveRequest',
        isHeader: false,
        prependIcon: MaterialSymbolsAssignmentAddOutlineSharp,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 6,
        isDisplayed: guardNewBulkRequest() === true,
        display: 'common.drawer.leaveNewRequestBulk',
        route: 'NewBulkLeaveRequest',
        isHeader: false,
        prependIcon: MaterialSymbolsAssignmentAddOutlineSharp,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 6,
        isDisplayed: guardCalendar() === true,
        display: 'common.drawer.LeaveCalendar',
        route: 'LeaveCalendar',
        isHeader: false,
        prependIcon: MaterialSymbolsEventNoteOutlineRounded,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 6,
        isDisplayed: guardLeaveSettingsAccess() === true,
        display: 'common.drawer.leaveSettings',
        route: 'LeaveSettings',
        isHeader: false,
        prependIcon: PhGearSixThin,
        appendBadge: false,
        isBeta:false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
    ],
  },
  {
    moduleId: 7,
    isDisplayed: guardEvaluationAccess() === true,
    display: 'common.drawer.evaluation',
    isHeader: true,
    prependIcon: SolarDocumentTextLineDuotone,
    appendBadge: false,
    color: 'hover:border-primary-500 hover:bg-primary-500/25',
    moduleName: 'EVALUATION',
    subPages: [
      {
        moduleId: 7,
        isDisplayed: guardEvaluationAccess() === true,
        display: 'common.drawer.evaluationList',
        route: 'Evaluations',
        isHeader: false,
        prependIcon: SolarDocumentsLineDuotone,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 7,
        isDisplayed: guardCreationEvaluation() === true,
        display: 'common.drawer.evaluationCreate',
        route: 'EvaluationCreation',
        isHeader: false,
        prependIcon: SolarDocumentMedicineBroken,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 7,
        isDisplayed: guardCampaign() === true,
        display: 'common.drawer.evaluationCampaigns',
        route: 'EvaluationCampaigns',
        isHeader: false,
        prependIcon: SolarMonitorLineDuotone,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 7,
        isDisplayed: guardSummaries() === true,
        display: 'common.drawer.evaluationSummaries',
        route: 'EvaluationSummaries',
        isHeader: false,
        prependIcon: SolarMonitorLineDuotone,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 7,
        isDisplayed: guardEvaluationSettingsAccess() === true,
        display: 'common.drawer.settings',
        route: 'EvaluationSettings',
        isHeader: false,
        prependIcon: PhGearSixThin,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
    ],
  },
  {
    moduleId: 12,
    isDisplayed: guardSurveyAccess() === true && (guardSurveyManage() === true || guardMySurveys() === true || guardSurveySettingsAccess() === true),
    display: 'common.drawer.survey',
    isHeader: true,
    prependIcon: SolarClipboardListLineDuotone,
    appendBadge: false,
    color: 'hover:border-primary-500 hover:bg-primary-500/25',
    moduleName: 'SURVEYS',
    subPages: [
      {
        moduleId: 12,
        isDisplayed: guardMySurveys() === true,
        display: 'common.drawer.surveyMine',
        route: 'MySurveys',
        isHeader: false,
        prependIcon: SolarClipboardCheckLineDuotone,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 12,
        isDisplayed: guardSurveyManage() === true,
        display: 'common.drawer.surveyList',
        route: 'Surveys',
        isHeader: false,
        prependIcon: SolarDocumentsLineDuotone,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 12,
        isDisplayed: guardSurveyManage() === true,
        display: 'common.drawer.surveyCreate',
        route: 'SurveyCreation',
        isHeader: false,
        prependIcon: SolarDocumentMedicineBroken,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 12,
        isDisplayed: guardSurveySettingsAccess() === true,
        display: 'common.drawer.settings',
        route: 'SurveySettings',
        isHeader: false,
        prependIcon: PhGearSixThin,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
    ],
  },
  {
    moduleId: 9,
    isDisplayed: guardTrainingAccess() === true,
    display: 'common.drawer.training',
    isHeader: true,
    prependIcon: SolarSquareAcademicCap2LineDuotone,
    appendBadge: false,
    color: 'hover:border-primary-500 hover:bg-primary-500/25',
    moduleName: 'TRAINING',
    isAlpha: false,
    isBeta: false,
    subPages: [
      {
        moduleId: 9,
        display: 'common.drawer.myTraining',
        route: 'MyTraining',
        isHeader: false,
        isDisplayed: guardMyTraining() === true,
        prependIcon: MdiTimelineClockOutline,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
        isAlpha: false,
        isBeta: false,
      },
      {
        moduleId: 9,
        display: 'common.drawer.trainingList',
        route: 'TrainingList',
        isHeader: false,
        isDisplayed: guardTrainingCatalog() === true,
        prependIcon: SolarDocumentsLineDuotone,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
        isAlpha: false,
        isBeta: false,
      },
      {
        moduleId: 9,
        display: 'common.drawer.trainingCalendar',
        route: 'TrainingPlanning',
        isHeader: false,
        isDisplayed: true,
        prependIcon: SolarCalendarLineDuotone,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
        isAlpha: false,
        isBeta: false,
      },
      {
        moduleId: 9,
        display: 'common.drawer.elearning',
        route: 'Elearning',
        isHeader: false,
        isDisplayed: guardElearningAccess() === true,
        prependIcon: SolarMonitorLineDuotone,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
        isAlpha: false,
        isBeta: false,
      },
      {
        moduleId: 9,
        display: 'common.drawer.trainingStats',
        route: 'TrainingStats',
        isHeader: false,
        isDisplayed: guardTrainingStats() === true,
        prependIcon: PhChartLineUpLight,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
        isAlpha: false,
        isBeta: false,
      },
      {
        moduleId: 9,
        display: 'common.drawer.trainingBudget',
        route: 'TrainingBudget',
        isHeader: false,
        isDisplayed: guardTrainingBudget() === true,
        prependIcon: SolarWalletMoneyOutline,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
        isAlpha: false,
        isBeta: false,
      },
      {
        moduleId: 9,
        display: 'common.drawer.trainingWishesAttribution',
        route: 'TrainingWishesAttribution',
        isHeader: false,
        isDisplayed: guardTrainingWishesAttribution() === true,
        prependIcon: SolarChecklistBold,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
        isAlpha: false,
        isBeta: false,
      },
      {
        moduleId: 9,
        isDisplayed: guardTrainingSettingsAccess() === true,
        display: 'common.drawer.settings',
        route: 'TrainingSettings',
        isHeader: false,
        prependIcon: PhGearSixThin,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
    ],
  },
  {
    moduleId: 19,
    isDisplayed: guardInvoiceAccess() === true,
    display: 'common.drawer.invoice',
    isHeader: true,
    prependIcon: SolarCalculatorLinear,
    appendBadge: false,
    color: 'hover:border-primary-500 hover:bg-primary-500/25',
    moduleName: 'INVOICES',
    isAlpha: false,
    isBeta: false,
    subPages: [
      {
        moduleId: 19,
        display: 'common.drawer.invoiceProjects',
        route: 'InvoiceProjects',
        isHeader: false,
        isDisplayed: true,
        prependIcon: PhListMagnifyingGlassDuotone,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
        isAlpha: false,
        isBeta: false,
      },
      {
        moduleId: 19,
        display: 'common.drawer.invoices',
        route: 'InvoiceList',
        isHeader: false,
        isDisplayed: true,
        prependIcon: SolarFileTextLineDuotone,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
        isAlpha: false,
        isBeta: false,
      },
      {
        moduleId: 19,
        display: 'common.drawer.invoiceToBeInvoiced',
        route: 'InvoiceToBeInvoiced',
        isHeader: false,
        isDisplayed: true,
        prependIcon: SolarCalculatorLinear,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
        isAlpha: false,
        isBeta: true,
      },
      {
        moduleId: 19,
        display: 'common.drawer.invoiceEInvoices',
        route: 'InvoiceEInvoices',
        isHeader: false,
        isDisplayed: isEInvoicingSalesEnabled(),
        prependIcon: MdiTransmissionTower,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
        isAlpha: false,
        isBeta: false,
      },
      {
        moduleId: 19,
        display: 'common.drawer.invoicePurchases',
        route: 'InvoicePurchases',
        isHeader: false,
        isDisplayed: true,
        prependIcon: SolarFileTextLineDuotone,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
        isAlpha: false,
        isBeta: true,
      },
      {
        moduleId: 19,
        display: 'common.drawer.invoiceSettings',
        route: 'InvoiceSettings',
        isHeader: false,
        isDisplayed: guardInvoiceSettingsAccess() === true,
        prependIcon: SolarFileTextLineDuotone,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
        isAlpha: false,
        isBeta: false,
      },
    ],
  },
  {
    moduleId: 13,
    display: 'common.drawer.expense',
    isHeader: true,
    prependIcon: SolarBillListLineDuotone,
    appendBadge: false,
    isDisplayed: guardExpenseAccess() === true,
    color: 'hover:border-primary-500 hover:bg-primary-500/25',
    moduleName: 'EXPENSE',
    isAlpha: false,
    subPages: [
      // {
      //   moduleId: 13,
      //   isDisplayed: true,
      //   display: 'New expense',
      //   route: 'NewExpense',
      //   isHeader: false,
      //   prependIcon: SolarDocumentAddLineDuotone,
      //   appendBadge: false,
      //   color: 'hover:border-primary-500 hover:bg-primary-500/25',
      // },
      {
        moduleId: 13,
        isDisplayed: guardExpenseCreation() === true,
        display: 'common.drawer.expenseReports',
        route: 'Reports',
        isHeader: false,
        prependIcon: SolarDocumentAddLineDuotone,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 13,
        isDisplayed: guardExpenseCreation() === true,
        display: 'common.drawer.expenseList',
        route: 'ExpensesList',
        isHeader: false,
        prependIcon: SolarDocumentAddLineDuotone,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 13,
        isDisplayed: guardExpenseSettings() === true,
        display: 'common.drawer.expenseSettings',
        route: 'ExpenseSettings',
        isHeader: false,
        prependIcon: PhGearSixThin,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
    ],
  },
  {
    moduleId: 23,
    display: 'common.drawer.dashboard',
    isHeader: true,
    prependIcon: SolarChartOutline,
    appendBadge: false,
    color: 'hover:border-primary-500 hover:bg-primary-500/25',
    moduleName: 'DASHBOARD',
    isDisplayed: guardDashboardAccess() === true,
    subPages: [
      {
        moduleId: 23,
        isDisplayed: guardProduction() === true,
        display: 'common.drawer.dashboardProduction',
        route: 'DashboardProduction',
        isHeader: false,
        prependIcon: SolarChartLineDuotone,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 23,
        isDisplayed: guardSales() === true,
        display: 'common.drawer.dashboardSales',
        route: 'DashboardSales',
        isHeader: false,
        prependIcon: SolarMoneyBagLineDuotone,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 23,
        isDisplayed: guardCashFlow() === true,
        display: 'common.drawer.dashboardCashflow',
        route: 'DashboardCashflow',
        isHeader: false,
        prependIcon: SolarWalletMoneyOutline,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 23,
        isDisplayed: guardResource() === true,
        display: 'common.drawer.dashboardResource',
        route: 'DashboardResource',
        isHeader: false,
        prependIcon: PhUserList,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
    ],
  },
  {
    moduleId: 25,
    display: 'common.drawer.alert',
    isHeader: true,
    prependIcon: MdiBellAlertOutline,
    appendBadge: false,
    color: 'hover:border-primary-500 hover:bg-primary-500/25',
    moduleName: 'ALERTS',
    isDisplayed: guardAlertAccess() === true && (guardMonitor() === true || guardBuilder() === true),
    subPages: [
      {
        moduleId: 25,
        isDisplayed: guardMonitor() === true,
        display: 'common.drawer.alertMonitor',
        route: 'AlertMonitor',
        isHeader: false,
        isBeta: false,
        prependIcon: MdiBellAlertOutline,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 25,
        isDisplayed: guardBuilder() === true,
        display: 'common.drawer.alertBuilder',
        route: 'AlertBuilder',
        isHeader: false,
        isBeta: false,
        prependIcon: PhGearSixThin,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
    ],
  },
  {
    moduleId: 8,
    display: 'common.drawer.salesFunnel',
    isHeader: true,
    prependIcon: SolarGraphOutline,
    appendBadge: false,
    color: 'hover:border-primary-500 hover:bg-primary-500/25',
    moduleName: 'SALESFUNNEL',
    isDisplayed: guardSalesFunnelAccess() === true,
    subPages: [
      {
        moduleId: 8,
        isDisplayed: guardSalesFunnelAccess() === true,
        display: 'common.drawer.salesFunnelFunnel',
        route: 'SalesFunnel',
        isAlpha: false,
        isBeta: false,
        isHeader: false,
        prependIcon: SolarGraphOutline,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 8,
        isDisplayed: guardClients() === true,
        display: 'common.drawer.salesFunnelClients',
        route: 'ClientsList',
        isAlpha: false,
        isBeta: false,
        isHeader: false,
        prependIcon: SolarUserBold,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 8,
        isDisplayed: guardContacts() === true,
        display: 'common.drawer.salesFunnelContacts',
        route: 'ContactsList',
        isAlpha: false,
        isBeta: false,
        isHeader: false,
        prependIcon: PhAddressBookLight,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 8,
        isDisplayed: guardActivities() === true,
        display: 'common.drawer.salesFunnelActivities',
        route: 'ActivitiesList',
        isAlpha: false,
        isBeta: false,
        isHeader: false,
        prependIcon: MdiTimelineClockOutline,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 8,
        isDisplayed: guardStats() === true,
        display: 'common.drawer.salesFunnelStats',
        route: 'Stats',
        isAlpha: false,
        isBeta: false,
        isHeader: false,
        prependIcon: SolarChart2Outline,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
      {
        moduleId: 8,
        isDisplayed: guardWorkflows() === true,
        display: 'common.drawer.salesFunnelWorkflows',
        route: 'WorkflowsList',
        isAlpha: false,
        isBeta: false,
        isHeader: false,
        prependIcon: PhGearSixThin,
        appendBadge: false,
        color: 'hover:border-primary-500 hover:bg-primary-500/25',
      },
    ]
  }
 

].reduce(shouldBeDisplayed, [])
